// extracted by mini-css-extract-plugin
module.exports =  {"info":"DemoContentStep-module__info___SMQ6M"};